import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { PractitionerSearchResult } from 'src/app/utils/interfaces/new/PractitionerSearchResult';
import { environment } from 'src/environments/environment';

interface RecipientTableDisplay {
  name: string;
  profession: string;
  city: string;
  mssanteAddress: string;
}

const RECIPIENT_SEARCH_LIMIT_PER_PAGE = 10;

@Component({
  selector: 'app-mss-recipient-search',
  templateUrl: './mss-recipient-search.component.html',
  styleUrls: [
    './mss-recipient-search.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class MssRecipientSearchComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public recipientsTable: Paginated<RecipientTableDisplay>;
  public recipientsTableColumnTable = [
    { title: 'Nom', data: 'name' },
    { title: 'Spécialité', data: 'profession' },
    { title: 'Ville', data: 'city' },
    { title: 'Adresse MSSanté', data: 'mssanteAddress' }
  ];

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;
  public isSearching = false;
  public result: PractitionerSearchResult;
  public noSearchYet = false;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _mssSrv: MssServiceFactory
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      exerciceName: [''],
      firstName: [''],
      professionSpeciality: [''],
      zip: [''],
      city: ['']
    });
  }

  public async doSearchRecipients(forceSearch = true, page = 1): Promise<void> {
    const practitionerName = this.formGroup.get('exerciceName').value;
    const firstName = this.formGroup.get('firstName').value;
    const profession = this.formGroup.get('professionSpeciality').value;
    const zip = this.formGroup.get('zip').value;
    const city = this.formGroup.get('city').value;

    this.isSearching = true;
    this.noSearchYet = true;
    try {
      this.result = await this._mssSrv.getService().findMSSRecipient({
          city,
          firstName,
          practitionerName,
          profession,
          zip,
        },
        RECIPIENT_SEARCH_LIMIT_PER_PAGE,
        page - 1,
        forceSearch
      );
      this._initTableDisplay(this.result);
    } catch (e) {
      console.error(e);
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        e?.error?.message || e.message
      );
    } finally {
      this.isSearching = false;
    }
  }

  public changePage(page: number): void {
    this.doSearchRecipients(false, page);
  }

  public selectRecipient(recipient: RecipientTableDisplay): void {
    this.closeModal(recipient.mssanteAddress);
  }

  public closeModal(recipient?: string): void {
    this.closeEmitter.emit(recipient);
  }

  private _initTableDisplay(practictioners: PractitionerSearchResult): void {
    const resultTmp: Array<RecipientTableDisplay> = [];
    for (const p of practictioners.result) {
      resultTmp.push({
        city: (p.city || '') + ' ' + `(${p.zip})`,
        name: (p.practitionerName || '') + ' ' + p.firstName || '',
        mssanteAddress: p.msSanteAddress || '',
        profession: p.profession || '',
      });
    }

    if (this.recipientsTable) {
      this.recipientsTable.objects = [...resultTmp];
      this.recipientsTable.page = practictioners.page + 1;
      this.recipientsTable.perpage = practictioners.perpage;
      this.recipientsTable.total = practictioners.total;
    } else {
      this.recipientsTable = {
        objects: resultTmp,
        page: practictioners.page + 1,
        perpage: practictioners.perpage,
        total: practictioners.total
      };
    }
  }

}
